'use client'

import type { ButtonVariant } from '@snowball-tech/common/components/blocks/Button'

import { getFullQualifiedUrl } from '@snowball-tech/common/helpers'

import isEmpty from 'lodash/fp/isEmpty'

import type { Block } from '@/types'

import TrackedButton from '@/components/Edition/Button'
import { isBlockEmpty, processContent } from '@/helpers/edition'

type Props = {
  block: Block
  editionUuid: string
}
export default function Button({ block, editionUuid }: Props) {
  const blockIsEmpty = isEmpty(block.props?.url)

  if (blockIsEmpty) {
    return false
  }

  const htmlId = `${block.type}-${block.id}`

  const { props = {} } = block

  const href = isEmpty(props.url)
    ? undefined
    : getFullQualifiedUrl(props?.url as string)

  return (
    <div className="w-full">
      <div id={htmlId} className="flex items-center justify-center">
        <TrackedButton
          editionUuid={editionUuid}
          href={href}
          {...(isEmpty(props.variant)
            ? {}
            : { variant: props.variant as ButtonVariant })}
        >
          {isBlockEmpty(block)
            ? (props.url as string)
            : processContent(block.content, editionUuid)}
        </TrackedButton>
      </div>
    </div>
  )
}
